<template>
  <div>
    <div class="js-upload uk-placeholder uk-text-center">
      <span data-uk-icon="cloud-upload"></span>&nbsp;
      <span class="uk-text-middle">{{ imageLabel }} hier rein ziehen oder </span>
      <div data-uk-form-custom>
        <input type="file" :multiple="multiple" />
        <span class="uk-link">klicken zum hochladen</span>
      </div>
    </div>
    <progress id="js-progressbar" class="uk-progress" value="0" max="100" hidden></progress>
    <div class="uk-grid" v-if="fileError">
      <div class="uk-width-1-1">
        <div class="uk-alert uk-alert-danger">
          Keine Bild Datei!
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Configuration from '@/configuration';
export default {
  props: {
    url: {
      type: String,
      required: true
    },
    type: {
      type: String,
      required: false
    },
    name: {
      type: String,
      required: false
    },
    id: {
      type: Number,
      required: true
    },
    multiple: {
      type: Boolean,
      required: false,
      default: false
    }
  },

  data() {
    return {
      images: [],
      uploadComplete: false,
      uploaded: [],
      fileError: false,
      imageCount: 0
    }
  },
  computed: {
    imageLabel() {
      return this.multiple ? 'Bild(er)' : 'Bild'
    }
  },

  mounted() {
    let $this = this
    const bar = document.getElementById('js-progressbar')
    this.$uikit.upload('.js-upload', {
      url: this.url,
      multiple: this.multiple,
      params: {
        type: this.type,
        name: this.name,
        id: this.id
      },

      beforeSend: e =>
        (e.headers = {
          Authorization: window.localStorage
            .getItem('localforage/ansolution/authtoken')
            .replaceAll('"', ''),
          'X-AUTH-TOKEN': Configuration.value('tenant')
        }),
      beforeAll: (e, fileList) => {
        $this.fileError = false
        var reader,
          files = fileList

        for (var i = 0; i < files.length; i++) {
          var file = files[i]

          if (!file.type.match('image')) {
            $this.fileError = true
            continue
          }

          reader = new FileReader()
          reader.onload = e => {
            $this.images.push(e.target.result)
          }
          reader.readAsDataURL(file)
        }
      },
      load: () => {},
      error: () => {},
      complete: e => {
        let json = JSON.parse(e.response)
        $this.uploaded.push(json)
        $this.imageCount++
        $this.$emit('uploaded', json)
      },
      loadStart: e => {
        bar.removeAttribute('hidden')
        bar.max = e.total
        bar.value = e.loaded
      },
      progress: e => {
        bar.max = e.total
        bar.value = e.loaded
      },
      loadEnd: e => {
        bar.max = e.total
        bar.value = e.loaded
      },
      completeAll: () => {
        //setTimeout(function () {
        bar.setAttribute('hidden', 'hidden')
        //}, 1000);
        $this.uploadComplete = true
      }
    })
  }
}
</script>
